export const pipelineGeneratorKeys = {
	all: ['crm', 'pipelineGenerator'],
	status: (generationId) => ['crm', 'pipelineGenerator', 'status', generationId],
	leads: (generationId) => ['crm', 'pipelineGenerator', 'leads', generationId],
};
